import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=01283515"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=01283515&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterTop: require('/app/components/FooterTop.vue').default,FooterBottom: require('/app/components/FooterBottom.vue').default,Footer: require('/app/components/Footer.vue').default})
